import { render, staticRenderFns } from "./AppointmentProductItems.vue?vue&type=template&id=38493fad&scoped=true&"
import script from "./AppointmentProductItems.vue?vue&type=script&lang=js&"
export * from "./AppointmentProductItems.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentProductItems.vue?vue&type=style&index=0&id=38493fad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38493fad",
  null
  
)

export default component.exports